import { HOME_PAGE_ERROR_CODE } from './constant';

export const URL = {
  // PgaeInfo: 'v2/homePage/homePageInfo', // 首页运营位
  PgaeInfo: 'v4/homePage/homePageInfo', // 首页运营位
  ShopList: 'v3/homePage/homeShopList', // 首页Feeds
  // ShopList: 'v4/homePage/homeShopList', // 首页Feeds
  SecPagePicList: 'v1/puzzle/component/preload', // 二级页头图配置接口
  locateJudge: 'v1/address/user/relocationAddress',
};

export async function homeRequest(url = '', data = {}, params = {}, headers = {}, showLoading = true): Promise<any> {
  // @ts-ignore
  const networkModule = Mach.requireModule('Network');
  const requestParams = {
    url,
    method: 'POST',
    params,
    data,
    headers,
    dataType: 'json',
  };
  // @ts-ignore
  const indicatorModule = Mach.requireModule('ActivityIndicator');
  if (showLoading) {
    indicatorModule.showLoading();
  }
  return new Promise<any>((resolve, reject) => {
    const callback = (result: any) => {
      if (showLoading) {
        indicatorModule.hideLoading();
      }
      if (result.error) {
        reject(result);
      } else {
        if (result.data && result.data.code === 0) {
          resolve(result.data.data);
        } else {
          //   Toast.show(errMsg || '请求异常，请重试', 2);
          reject(result);
        }
      }
    };
    networkModule?.request?.(requestParams, callback);
  });
}

// 不再服务范围code
export function isNotServiceWithCode(code: number) {
  if (code === undefined) {
    return false;
  }
  let result = false;
  switch (code) {
    case HOME_PAGE_ERROR_CODE.PRE_PAGE_LOGIN_CODE:
    case HOME_PAGE_ERROR_CODE.PRE_PAGE_NO_LOGIN_COE:
    case HOME_PAGE_ERROR_CODE.LOGIN_CODE:
    case HOME_PAGE_ERROR_CODE.NO_LOGIN_CODE:
    case HOME_PAGE_ERROR_CODE.NO_SERVICE:
    case HOME_PAGE_ERROR_CODE.NUCLEAR_BUTTON:
      result = true;
      break;
    default:
      break;
  }
  return result;
}

export function isNuclearCode(code: number) {
  return code === HOME_PAGE_ERROR_CODE.NUCLEAR_BUTTON;
}

export function isNonEmptyObject(value: any): value is object {
  return value !== null && typeof value === 'object' && !Array.isArray(value) && Object.keys(value).length > 0;
}
